import { useTranslation } from 'cng-web-lib'
import UserNamePasswordKeys from 'src/constants/locale/key/UserNamePassword'
import Namespace from 'src/constants/locale/Namespace'


export const useTranslations = () => {

  const { translate } = useTranslation([Namespace.USER_NAME_PASSWORD])

  let changePassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.CHANGE_PASSWORD
  )

  let securityQuestion = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.SECURITY_QUESTION
  )

  let userId = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.USER_ID
  )

  let oldPassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.PASSWORD
  )

  let newPassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.NEW_PASSWORD
  )

  let confirmNewPassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.CONFIRM_NEW_PASSWORD
  )

  let setNewPassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.SET_NEW_PASSWORD
  )

  let helpText1 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.HELP_TEXT_1
  )

  let helpText2 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.HELP_TEXT_2
  )

  let helpText3 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.HELP_TEXT_3
  )

  let helpText4 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.HELP_TEXT_4
  )

  let errorMessage1 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_1
  )

  let errorMessage2 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_2
  )

  let errorMessage3 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_3
  )

  let errorMessage4 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_4
  )

  let errorMessage5 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_5
  )

  let errorMessage6 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_6
  )

  let errorMessage15 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_15
  )

  let errorMessage16 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_16
  )

  let errorMessage17 = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.ERROR_MESSAGE_17
  )

  return {
    changePassword,
    securityQuestion,
    userId,
    oldPassword,
    newPassword,
    confirmNewPassword,
    setNewPassword,
    helpText1,
    helpText2,
    helpText3,
    helpText4,
    errorMessage1,
    errorMessage2,
    errorMessage3,
    errorMessage4,
    errorMessage5,
    errorMessage6,
    errorMessage15,
    errorMessage16,
    errorMessage17
  }
}